"use client";
import React from "react";
import CtaVersion from "../buttons/CtaVersion";
import { cn } from "@/lib/utils";

interface IButton {
  ctaLabel: string;
  ctaLink: string;
  intent: "primary" | "secondary" | "ghost" | undefined;
  background: string;
  hoverBackground: string;
  textColor: string;
  id: string;
  internalLabel: string;
}

const MobileFooterWithCta = ({ buttons }: { buttons: IButton[] }) => {
  return (
    <div className="fixed lg:hidden bottom-0 left-0 right-0 z-[270] flex justify-center w-full gap-[2px] p-[2px] bg-white">
      {buttons.map((cta: IButton) => {
        const className = `enabled:hover:bg-${cta.hoverBackground} rounded-none w-full 
        max-w-full flex-1 enabled:active:bg-${cta.background} enabled:active:text-${cta.textColor}`;
        return (
          <CtaVersion
            gtmEvent={true}
            key={cta.id}
            {...cta}
            className={cn(className)}
            intent="primarySmall"
            fullLength
          />
        );
      })}
    </div>
  );
};

export default MobileFooterWithCta;
